import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SatisfinderAuthContext = createContext(null);

export function SatisfinderAuthProvider({ children }) {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch(`${API}/satisfinder/me`, { credentials: 'include' });
      if (res.ok) {
        setMe(await res.json());
      } else {
        setMe(null);
      }
    } catch {
      setMe(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const res = await fetch(`${API}/satisfinder/login`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    const d = await res.json().catch(() => ({}));
    if (!res.ok) return { ok: false, error: d.detail || 'Login failed' };
    if (d.ok === false && d.next === 'verify_email') {
      return { ok: false, next: 'verify_email', email: d.email };
    }
    await refresh();
    return { ok: true };
  };

  const logout = async () => {
    await fetch(`${API}/satisfinder/logout`, { method: 'POST', credentials: 'include' });
    setMe(null);
  };

  return (
    <SatisfinderAuthContext.Provider value={{ me, loading, refresh, login, logout }}>
      {children}
    </SatisfinderAuthContext.Provider>
  );
}

export function useSatisfinderAuth() {
  const ctx = useContext(SatisfinderAuthContext);
  if (!ctx) throw new Error('useSatisfinderAuth must be used within SatisfinderAuthProvider');
  return ctx;
}

export { API as SATISFINDER_API };
